module.exports = __webpack_public_path__ + "img/Alex-Bland.65445945.jpg";